import CityZoneHub from '../components/CityZoneHub';

export default function BenahavisPage() {
  return (
    <CityZoneHub
      slug="benahavis"
      name="Benahavís"
      heroSubtitle="Cubrimos todo Benahavís y urbanizaciones premium: La Quinta, El Madroñal, El Paraíso."
      barrios={["Centro pueblo", "La Quinta", "El Madroñal", "El Paraíso", "La Alquería"]}
      faqItems={[]}
    />
  );
}